import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Link, useLocation, useParams } from 'react-router-dom';
import './referal.css';
import { IconButton } from '@mui/material';
import axios from 'axios';
import { FacebookProvider, ShareButton } from 'react-facebook';
import { MdContentCopy } from 'react-icons/md';
import { GrLocation } from 'react-icons/gr';
import { AiOutlinePhone } from 'react-icons/ai';
import Loader from '../Loader';
import email from '../../assests/email.png';
import text from '../../assests/text.png';
import mayur from '../../assests/mayur.png';

const shareButtonSx = {
  borderRadius: '12px',
  textTransform: 'none',
  fontWeight: 500,
  boxShadow: 'none',
  pl: 0.5,
  pr: 2,
  '&:hover': { boxShadow: '0 4px 12px -4px rgba(15, 23, 42, 0.35)' },
};

function MainReferral({ baseURL }) {
  const [data, setData] = useState(null);
  const {
    linkid, templateid, contactid, type,
  } = useParams();
  const [loading, setLoading] = useState(false);
  console.log('base URl',baseURL);
  useEffect(() => {
    getReferralData();
  },[]);

  const getReferralData = async () => {
    setLoading(true);
    const response = await axios.get(`${baseURL}/testing/refer-us/${linkid}/${templateid}/${contactid}`,{
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    console.log(response, 'this is responsessssssss');
    if (response.data.status === 'success') {
      setData(response?.data?.data);
      setLoading(false);
    }
  };

  const updateFacebook = async () => {
    const response = await axios.put(`${baseURL}/refferal/facebook/${linkid}?send_via=${type}`);
    console.log('updateFacebook res', response);
    window.open(data?.template?.referral_link_share_1 === null ? '#' : data?.template?.referral_link_share_1, '_blank');
  };

  const updateMessenger = async () => {
    const response = await axios.put(`${baseURL}/refferal/messenger/${linkid}?send_via=${type}`);
    console.log('updateMessenger res', response);
    window.open(data?.template?.referral_link_share_1 === null ? '#' : data?.template?.referral_link_share_1, '_blank');
  };

  const handleCopy = (val) => {
    navigator.clipboard.writeText(val);
    // toast.success('Referral code copied');
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      <div className="qs-card">
        <div className="qs-card-body space-y-8">
          <div className="space-y-2">
            <div className="text-lg font-semibold tracking-tight text-slate-900">{data?.name}</div>
            {data?.address !== null && (
            <div className="flex items-start gap-2 text-sm text-slate-500">
              <span className="mt-0.5 shrink-0 opacity-70"><GrLocation /></span>
              <span>
                {data?.address}
              </span>
            </div>
            )}

            {data?.phone !== null && (
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span className="shrink-0 opacity-70"><AiOutlinePhone /></span>
              <span>
                {data?.phone}
              </span>
            </div>
            )}

          </div>

          <div className="flex justify-center">
            {data?.template.referral_image !== null && (
              <figure>
                <img src={data?.template?.referral_image} alt="logo" className="max-h-[350px] w-auto max-w-full rounded-2xl shadow-md ring-1 ring-black/5 sm:max-w-[250px]" />
              </figure>
            )}
          </div>

          <div className="flex flex-col items-center space-y-4 text-center">
            <div className="qs-title">
              {data?.refer_heading}
            </div>
            <div className="qs-subtitle">
              {data?.refer_body}
              {' '}
              <p className="mx-auto mt-4 flex w-fit items-center gap-1 rounded-xl border border-dashed border-slate-300 bg-slate-50 py-1 pl-4 pr-1 text-lg font-semibold tracking-wider text-slate-900">
                {data?.code}
                <IconButton onClick={() => handleCopy(data?.code)}>
                  <MdContentCopy />
                </IconButton>
              </p>
            </div>
          </div>

          <div>
            <p className="qs-label">Share your referral link :</p>
            <div className="break-all rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-blue-600 transition hover:border-blue-300 hover:bg-blue-50/50">
              <Link to={`/r/${linkid}/${templateid}/${contactid}`} target="_blank">
                {`https://store.salescaptain.com/refer/${linkid}`}
              </Link>
            </div>
          </div>

          <div>
            <div className="flex flex-wrap gap-3">
              <div>
                {data?.template?.referral_platform_share_1 === 'Facebook' && (
                <Link to={data?.template?.referral_link_share_1 === null ? '#' : data?.template?.referral_link_share_1} target="_blank" style={{ textDecoration: 'none' }}>
                  <FacebookProvider appId="123456789">
                    <ShareButton href="http://www.facebook.com" className="my-classname">
                      Share
                    </ShareButton>
                  </FacebookProvider>
                  <Button
                    variant="contained"
                    sx={shareButtonSx}
                    style={{ maxWidth: '150px',backgroundColor: '#455b76' }}
                    onClick={updateFacebook}
                  >
                    <IconButton>
                      <img src={email} alt="no_image" />
                    </IconButton>
                    Share
                  </Button>
                </Link>
                )}
              </div>

              <div>
                {data?.template?.referral_platform_share_2 === 'Email' && (
                <Link to={`/sr/${linkid}/3/${templateid}/${contactid}/text`} target="_blank" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    sx={shareButtonSx}
                    style={{ maxWidth: '150px',backgroundColor: '#455b76' }}
                  >
                    <IconButton>
                      <img src={email} alt="no_image" />
                    </IconButton>
                    Email
                  </Button>
                </Link>
                )}
              </div>

              <div>
                {data?.template?.referral_platform_share_3 === 'Text' && (
                <Link to={`/sr/${linkid}/4/${templateid}/${contactid}/text`} target="_blank" style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    sx={shareButtonSx}
                    style={{ maxWidth: '150px',backgroundColor: '#4caf50' }}
                  >
                    <IconButton>
                      <img src={text} alt="no_image" />
                    </IconButton>
                    Text
                  </Button>
                </Link>
                )}
              </div>

              <div>
                {data?.template?.referral_platform_share_4 === 'Messenger' && (
                  <Link to={data?.template?.referral_link_share_1 === null ? '#' : data?.template?.referral_link_share_1} target="_blank" style={{ textDecoration: 'none' }}>
                    <Button
                      variant="contained"
                      sx={shareButtonSx}
                      style={{ maxWidth: '150px',backgroundColor: '#455b76' }}
                      onClick={updateMessenger}
                    >
                      <IconButton>
                        <img src={email} alt="no_image" />
                      </IconButton>
                      Messenger
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="border-t border-slate-100 pt-6 text-slate-600">
            <p>Happy referring!</p>
            <p className="font-semibold text-slate-900">{data?.name}</p>
          </div>
        </div>

        <div className="qs-footer-note flex-wrap">
          To unsubscribe click this
          {'  '}
          <Link
            className="qs-link pl-1"
            to={`/unsubscribe/${data?.company_id}/${contactid}/${type}`}
          >
            link
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MainReferral;
